import React, { useCallback, useEffect, useState } from 'react'
import * as yup from 'yup';

// Helper
import { createCssClass } from '../../helpers/common';

// css
import './CheckBoxInput.css';

interface Props extends React.HTMLProps<HTMLInputElement> {
  id: string;
  name: string;
  label: string;
  checked: boolean;

  suggestion?: string;
  required?: boolean;

  yupSchema?: yup.BooleanSchema<boolean>;
  validateNow?: boolean;
}

const CheckBoxInput: React.FC<Props> = ({ id, name, label, checked, className, suggestion, required = false, validateNow = false, yupSchema, ...rest }) => {

  const [validationMessage, setValidationMessage] = useState<string>('');

  const validateResult = useCallback((value: boolean) => {
    if (!yupSchema) return;
    yupSchema.validate(value, { strict: true })
      .then(() => setValidationMessage(''))
      .catch((err: yup.ValidationError) => setValidationMessage(err.message));
  }, [yupSchema]);

  useEffect(() => {
    validateResult(checked);
  }, [checked, validateResult]);

  if (validateNow === true) validateResult(checked);

  const onBlur = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.checked;
    validateResult(value);
  };

  return (

    <div className={createCssClass(['checkbox-input', name])}>

      <input
        type="checkbox"
        id={id}
        className={createCssClass([name, className, validationMessage ? 'invalid' : ''])}
        checked={checked}
        onBlur={onBlur}
        {...rest}
      />

      <label className={createCssClass([name])} htmlFor={id}>{label}
        {/* {!required && <span className='optional'> (opzionale)</span>} */}
      </label>

      {!!suggestion && <div className='suggestion'>{suggestion}</div>}
      {!!validationMessage && <div className={createCssClass(['validation-message'])}>{validationMessage}</div>}

    </div>
  );
}

export default CheckBoxInput;